export default {"src":"/_next/static/media/6.693f2cbd.svg","height":140,"width":119,"blurWidth":0,"blurHeight":0};